module.exports = __webpack_public_path__ + "img/img_yuyue.1e13c570.jpg";